{
  "schemaVersion": 1,
  "id": "free-grid-joints",
  "version": "1.0",
  "name": "Free layout: shelves and uprights housed where they meet; spine shelves deep-housed with hidden brackets",
  "family": "free-grid",
  "familyId": "free-grid",
  "jointFamily": "mixed",
  "provisional": true,
  "reviewer": null,
  "reviewedAt": null,
  "selfAuthored": true,
  "author": "David Mansaray",
  "authoredAt": "2026-10-09",
  "sources": [
    "research/taxonomy.md §1.5 Spine / tree: shelves housed into the spine with a stopped housing plus a hidden bracket; every shelf a pure cantilever; must be wall-fixed",
    "research/taxonomy.md §1.3 Offset grid: short members housed into the boards above and below; open backs need housings",
    "research/stress/pilot-v1 REPORT-r2 R2-07: irregular layouts (p14 E-shape, p16 cubbies) need a family of independent boards",
    "Offset grid joints.json (fasteners, wall fixing, anti-tip, tolerances) carried over"
  ],
  "joint": "Shelves and uprights placed independently. A board that ends at another is housed into it (one third of the thickness); at a corner where both end the upright runs through and the shelf is glued and screwed into it; where a shelf runs across an upright the upright is cut and each piece housed into the shelf. A shelf held by one upright only is housed 15 mm deep with two 12 mm steel floating-shelf rods set 120 mm into the upright and the shelf.",
  "joints": [
    {
      "at": "shelf-upright",
      "kind": "housed-dado",
      "params": {
        "depthRatio": 0.3333
      },
      "note": "A shelf ending at an upright that runs on past it."
    },
    {
      "at": "upright-shelf",
      "kind": "housed-dado",
      "params": {
        "depthRatio": 0.3333
      },
      "note": "An upright standing on, or stopping under, a shelf that runs on past it; and each piece of an upright a shelf runs through."
    },
    {
      "at": "corner",
      "kind": "screwed-butt",
      "params": {
        "screwSpec": "4.0 × 50 mm countersunk"
      },
      "note": "A corner where both boards end: the upright runs through, the shelf is glued and screwed (plugged in solid timber)."
    },
    {
      "at": "spine-shelf",
      "kind": "housed-dado",
      "params": {
        "depthRatio": 0.3333
      },
      "note": "A shelf held by one upright: housed, plus two hidden 12 mm steel rods (cantilever-bracket)."
    }
  ],
  "envelope": {
    "W": {
      "min": 3000,
      "max": 24000
    },
    "H": {
      "min": 3000,
      "max": 22000
    },
    "D": {
      "min": 1500,
      "max": 4500
    },
    "n": {
      "min": 1,
      "max": 16
    },
    "minOpeningTicks": 1000
  },
  "limits": {
    "maxSpanMm": 800,
    "maxCantileverRatio": 0.35,
    "minOpeningMm": 100
  },
  "edgeAllowanceTicks": 20,
  "cutAllowanceTicks": {
    "l": 0,
    "w": 0
  },
  "arrisMm": 0.6,
  "intendedUse": "Domestic books and objects; shelves loaded evenly. Not for climbing, not structural.",
  "loadStatement": "Self-authored: no rated load. Books and objects loaded evenly along each shelf; heaviest items on the lowest shelves.",
  "edgeTreatment": "Plywood: exposed ply edges, sanded arris 0.6 mm, lacquered with the faces. Solid timber: planed edges, 1 mm arris, oiled with the faces.",
  "fasteners": [
    {
      "id": "carcass-screw",
      "spec": "4.0 × 50 mm countersunk wood screw",
      "qtyRule": "per-joint",
      "perJoint": 3,
      "use": "Through the sides into each horizontal, 3 per joint at 25 mm from the front and back edges and centred; pilot 2.5 mm, clearance 4.5 mm; PVA glue on all butt joints."
    },
    {
      "id": "back-screw",
      "spec": "3.5 × 20 mm pan-head screw",
      "qtyRule": "back-perimeter-and-shelves",
      "centresMm": 150,
      "use": "Through the back into the sides, top, bottom and every shelf at 150 mm centres, glued."
    },
    {
      "id": "wall-bracket",
      "spec": "Steel angle bracket with fixings suited to the wall",
      "qtyRule": "fixed",
      "qty": 2,
      "use": "Under the top panel into studs, or with masonry plugs or cavity anchors suited to the wall."
    }
  ],
  "backFixing": {
    "method": "Open back: the housings and the wall fixing take the racking.",
    "spacingMm": 150,
    "rackingNote": "Square each junction as it is glued; a free layout with no back depends on its housings and the wall fixing."
  },
  "wallFixing": {
    "required": true,
    "method": "Two steel angle brackets under the top panel, screwed into studs or with fixings suited to the wall (masonry plugs or cavity anchors).",
    "hardware": "2 × steel angle bracket, screws and plugs to suit the wall"
  },
  "antiTip": {
    "required": true,
    "method": "Required above 1000 mm tall: wall fixing as above, plus an anti-tip strap rated for the cabinet. Load the lowest shelves first."
  },
  "warnings": {
    "maxShelfSpanMm": 800,
    "antiTipAboveMm": 1000
  },
  "assemblySteps": [
    "Glue up any solid panels listed as glue-ups first; flatten and cut to finished size.",
    "Mark every shelf datum on the uprights and every upright position on the shelves, from the same ends.",
    "Cut the housings; for each spine shelf, also drill the two 12 mm rod holes 120 mm deep into the upright and the shelf.",
    "Sand faces to 180 grit and break every arris.",
    "Assemble from the bottom up: the uprights standing on the floor or the bottom board, then each shelf and the pieces above it; glue the corners and screw them.",
    "Finish (two coats, de-nib between).",
    "Install: fix to the wall before loading; spine shelves must not be loaded until the wall fixing is in."
  ],
  "markingDrilling": [
    "Mark every shelf datum (underside from the floor) on the inside face of both verticals, measured from the same (bottom) end.",
    "Screw centres at mid-thickness above each datum line, at 25 mm from the front and back edges and centred.",
    "Clearance 4.5 mm and countersink through the sides; pilot 2.5 mm into the panel edges."
  ],
  "installation": [
    "Stand the bookcase in place and check it is level and plumb; pack under the sides if the floor is uneven.",
    "Fix two angle brackets under the top panel into the wall (studs, or plugs or anchors suited to the wall).",
    "Fit the anti-tip strap before loading any shelf.",
    "Load the lowest shelves first."
  ],
  "tolerances": {
    "panelLength": 0.5,
    "panelWidth": 0.5,
    "squareness": "≤ 1 mm over the diagonal",
    "shelfDatum": 1
  }
}